export const languages = ["en", "es"];
